import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'

import { borderRadius, greys } from 'assets/themes/theme-default'
import svg from 'assets/svg'

import SVG from 'core/components/svg'

import { fileShape } from '../../shapes'

const Icon = styled(SVG)`
  width: 20px;
  height: 20px;
  fill: #ffffff;
  vertical-align: middle;
  cursor: pointer;
`

const UploadImageItemWrapper = styled.div`
  .item {
    position: relative;
    width: 124px;
    height: 124px;
    border: 1px solid ${greys.light1};
    border-radius: ${borderRadius.base};
    background: white;
    margin-bottom: 8px;
    padding: 8px;
  }
  .status-done {
    cursor: grab;
  }
  .status-done:active {
    cursor: grabbing;
  }
  .status-error {
    border-color: #f5222d;
  }
  .info-wrapper::before {
    position: absolute;
    border-radius: ${borderRadius.base};
    z-index: 1;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    opacity: 0;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    content: ' ';
  }
  .info-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .info-wrapper img {
    border-radius: ${borderRadius.base};
    width: inherit;
    height: inherit;
  }
  .actions {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 10;
    white-space: nowrap;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    opacity: 0;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
  }
  .item:hover .info-wrapper::before {
    opacity: 1;
  }
  .item:hover .actions {
    opacity: 1;
  }

  .uploading {
    padding: 34px 9px 0 9px;
  }
  .progress-outer {
    margin-top: 10px;
    display: inline-block;
    background-color: #f5f5f5;
    height: 2px;
    width: 100%;
  }
  .progress-normal {
    background-color: #1890ff;
  }
  .progress-success {
    background-color: #52c41a;
  }
`

const UploadImageItem = ({ intl, ...props }) => {
  const { file } = props

  const handlePreview = () => props.onPreview(props.file)
  const handleDownload = () => props.onDownload(props.file)
  const handleRemove = () => props.onRemove(props.file)

  return (
    <UploadImageItemWrapper style={{ margin: '0 auto', width: '124px' }}>
      <div className={`item status-${file.status}`}>
        {file.status !== 'uploading' ? (
          <>
            <div className="info-wrapper">
              {file.status === 'error' && <span>{file.name}</span>}
              {file.status === 'done' && (
                <img src={`${file.url}&width=124&height=124&crop=1`} alt={file.name} />
              )}
            </div>
            <i className="actions">
              {file.status !== 'error' && (
                <>
                  <Icon onClick={handlePreview} svg={svg.eye} />
                  <Icon onClick={handleDownload} svg={svg.download} />
                </>
              )}
              <Icon onClick={handleRemove} svg={svg.deleteOutline} />
            </i>
          </>
        ) : (
          <div className="uploading">
            <span>Chargement...</span>
            <div className="progress-outer">
              <div
                className={`progress-${file.percent < 100 ? 'normal' : 'success'}`}
                style={{ width: `${file.percent}%`, height: '2px' }}
              />
            </div>
          </div>
        )}
      </div>
    </UploadImageItemWrapper>
  )
}

UploadImageItem.propTypes = {
  intl: PropTypes.shape().isRequired,
  file: fileShape.isRequired,
  onPreview: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired
}

export default injectIntl(UploadImageItem)
